<template>
    <MenuPage></MenuPage>
    <div class="content">
        <main class="card" role="region" aria-label="Perfil de usuario">
            <div class="profile-row">
                <div class="avatar">{{ initials }}</div>
                <div class="info">
                    <p class="name">{{ name }}</p>
                    <p class="email">{{ email }}</p>
                </div>
            </div>


            <div class="form-row">
                <input v-model="name" class="input" placeholder="Nombre completo">
                <input v-model="email" class="input" placeholder="Correo">
                <div class="actions">
                    <button class="btn" @click="restore">Restaurar</button>
                    <button class="btn primary" @click="save">Guardar</button>
                </div>
            </div>


            <div class="meta">
                <span>Miembro desde <strong>2024</strong></span>
                <small style="opacity:.9">Avatar con iniciales — sin imagen</small>
            </div>
        </main>
    </div>
</template>

<script setup>
import MenuPage from './MenuPage.vue';
import { ref, computed } from 'vue'


const initialName = 'Alan Guzmán'
const initialEmail = 'alan.guzman@example.com'


const name = ref(initialName)
const email = ref(initialEmail)


const initials = computed(() => {
    if (!name.value) return ''
    const parts = name.value.trim().split(/\s+/)
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
})


function save() {
    alert('Guardado ✓')
}


function restore() {
    name.value = initialName
    email.value = initialEmail
}

</script>


<style scoped>
:root {
    --bg: #0f1724;
    --card: #0b1220;
    --muted: #94a3b8;
    font-family: Inter, ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
}

.card {
    width: 100%;
    max-width: 700px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.03), rgba(255, 255, 255, 0.02));
    border-radius: 16px;
    padding: 22px;
    box-shadow: 0 8px 30px rgba(2, 6, 23, 0.6), inset 0 1px 0 rgba(255, 255, 255, 0.02);
    border: 1px solid rgba(255, 255, 255, 0.03);
    margin: 5% auto;
    background: white;
}


.profile-row {
    display: flex;
    gap: 16px;
    align-items: center
}


.avatar {
    height: 84px;
    width: 84px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 32px;
    letter-spacing: 0.6px;
    color: white;
    background: linear-gradient(135deg, #7c3aed, #06b6d4);
    box-shadow: 0 6px 18px rgba(12, 18, 30, 0.6), 0 1px 0 rgba(255, 255, 255, 0.03) inset;
    flex-shrink: 0;
}


.info {
    flex: 1;
    min-width: 0
}

.name {
    font-size: 18px;
    font-weight: 700;
    margin: 0 0 4px 0
}

.email {
    font-size: 13px;
    color: #94a3b8;
    margin: 0
}


.actions {
    display: flex;
    gap: 8px;
    margin-top: 16px
}

.btn {
    padding: 10px 14px;
    border-radius: 10px;
    border: 0;
    background: rgba(255, 255, 255, 0.04);
    color: inherit;
    font-weight: 600;
    cursor: pointer;
    backdrop-filter: blur(4px);
    box-shadow: 0 4px 12px rgba(2, 6, 23, 0.5);
}

.btn.primary {
    background: linear-gradient(90deg, #7c3aed, #06b6d4);
    color: white;
    box-shadow: 0 8px 20px rgba(124, 58, 237, 0.18);
}


.meta {
    margin-top: 14px;
    padding-top: 12px;
    border-top: 1px dashed rgba(255, 255, 255, 0.03);
    font-size: 13px;
    color: #94a3b8;
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: space-between
}


.form-row {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 14px
}

.input {
    padding: 10px 12px;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.04);
    background: transparent;
    color: inherit
}


@media (max-width:420px) {
    .avatar {
        height: 72px;
        width: 72px;
        font-size: 28px
    }

    .card {
        padding: 18px
    }
}
</style>